import { render, staticRenderFns } from "./CardPedidoFinalizadoInsumos.vue?vue&type=template&id=55fce75d&"
import script from "./CardPedidoFinalizadoInsumos.vue?vue&type=script&lang=js&"
export * from "./CardPedidoFinalizadoInsumos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports